import './TransactionItemDetail.scss'

import { Link } from 'react-router-dom'
import {
    getRecurrenceDisplayString,
    formatCurrency,
} from '../../utilities/general-utils'
import { IconSnowball } from '../../assets/icons'
import { dateHandler } from '../../utilities/date-utils'

const TransactionItemDetail = ({
    item
}) => {
    const isNegativeTransaction = item.amount < 0

    return (
        <Link
            to={`/transaction/${item.id}`}
            style={{
                textDecoration: 'none',
                color: 'inherit',
            }}
        >
            <div className={`itemDetail`}>
                <div className={`itemDetail-left`}>
                    <div className={`itemTitle`}>
                        {item.title} {item.is_snowball ? (<IconSnowball />) : null}
                    </div>

                    <div className={`itemCategory`}>
                        {item.category}{item.subcategory && ` - ${item.subcategory}`}
                    </div>

                    <div className={`itemDate`}>
                        <div className={`itemDateStart`}>
                            {item.start_date ? dateHandler.toDisplayFormat(item.start_date) : null}
                        </div>
                        {item.end_date ? <div className={`itemDateEnd`}><span className="text-weight-normal" style={{margin: '0 .25rem'}}>&mdash;</span>{dateHandler.toDisplayFormat(item.end_date)}</div> : null}
                    </div>
                </div>

                <div className={`itemDetail-right`}>
                    <div className={`itemFrequency`}>
                        {getRecurrenceDisplayString(item)}
                    </div>

                    <div className={`itemAmountWrap`}>
                        <div className={`itemAmount ${isNegativeTransaction ? `negativeAmount` : ''}`}>
                            {formatCurrency(item.amount)}
                        </div>                    
                    </div>
                </div>
            </div>
        </Link>
    )
}

export default TransactionItemDetail